import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList,
} from "recharts";

const COLORS = ["#48A0DC", "#2B7AB5", "#1A5A8A", "#F59E0B", "#D97706", "#10B981"];

/* Map funnel stage key → CRM status filter for My Leads */
const STAGE_TO_STATUS = {
  new: "New",
  contacted: "Contacted",
  qualified: "Qualified",
  demo: "Demo Scheduled",
  demoCompleted: "Demo Completed",
  won: "Won",
};

function SRFunnel({ data, loading, error, onStageClick }) {
  if (error) {
    return (
      <div className="dashboard-card-v2">
        <div className="dashboard-card-v2-header">
          <i className="fas fa-filter" />
          <span>My Funnel</span>
        </div>
        <div className="dashboard-card-v2-body">
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        </div>
      </div>
    );
  }

  const stages = Array.isArray(data?.stages) ? data.stages : [];
  const chartData = stages.map((s) => ({
    key: s.key,
    name: s.label,
    count: s.count,
    conversion: s.conversion,
  }));

  const handleBarClick = (entry) => {
    if (!entry || !entry.key) return;
    const status = STAGE_TO_STATUS[entry.key];
    if (status && typeof onStageClick === "function") {
      onStageClick(status);
    }
  };

  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-filter" />
        <span>My Funnel</span>
        {data?.total != null && (
          <span className="dashboard-card-v2-count">{data.total} leads</span>
        )}
      </div>
      <div className="dashboard-card-v2-body">
        {loading ? (
          <div className="dashboard-skeleton-block" style={{ height: 220 }} />
        ) : chartData.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-chart-bar" />
            <p>No funnel data yet.</p>
          </div>
        ) : (
          <>
            <div style={{ width: "100%", height: 220 }}>
              <ResponsiveContainer>
                <BarChart data={chartData} margin={{ top: 20, right: 16, left: 0, bottom: 0 }}>
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                  <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                  <Tooltip
                    formatter={(value, _name, props) =>
                      [`${value} leads (${props.payload.conversion}% conversion) — click to view`, ""]
                    }
                  />
                  <Bar
                    dataKey="count"
                    radius={[6, 6, 0, 0]}
                    onClick={handleBarClick}
                    cursor="pointer"
                  >
                    {chartData.map((_, i) => (
                      <Cell key={i} fill={COLORS[i % COLORS.length]} />
                    ))}
                    <LabelList
                      dataKey="count"
                      position="top"
                      style={{ fontSize: 11, fill: "#0A1A4A" }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="sr-funnel-conversions">
              {stages.slice(1).map((s, i) => {
                const status = STAGE_TO_STATUS[s.key];
                return (
                  <button
                    key={s.key}
                    type="button"
                    className="sr-funnel-conversion-item sr-funnel-conversion-item--clickable"
                    onClick={() => status && onStageClick && onStageClick(status)}
                  >
                    <span className="sr-funnel-conversion-label">
                      {stages[i].label} → {s.label}
                    </span>
                    <span className="sr-funnel-conversion-value">{s.conversion}%</span>
                  </button>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SRFunnel;